import { QuizOrFolder, QuizzesItemType } from '../types';

export type QuizItemCache = {
  itemById: Record<string, QuizOrFolder>;
  itemIdByType: Record<QuizzesItemType, string[]>;
  rootItems: string[];
};

export const toQuizItemCache = (
  aggregator: QuizItemCache,
  quizOrFolder: QuizOrFolder
): QuizItemCache => {
  aggregator.itemById[quizOrFolder.uniqueId] = quizOrFolder;
  aggregator.itemIdByType[quizOrFolder.type] = [
    ...aggregator.itemIdByType[quizOrFolder.type],
    quizOrFolder.uniqueId,
  ];

  if (quizOrFolder.parentId === null) {
    aggregator.rootItems = [...aggregator.rootItems, quizOrFolder.uniqueId];
  }
  return aggregator;
};
